import {
    Box,
    Button,
    CircularProgress,
    Paper,
    Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useApi } from '../../../../api';
import { UserTrackingType } from '../../../../api/endpoints/user-tracking';
import { useAlertMessage } from '../../../providers/alert-provider';
import { commonSx, plainLinkStyle } from '../../common-styles';
import { TrackingForm } from './tracking-form';

const defaultTracking: UserTracking = {
    userTrackingId: 0,
    userId: '',
    title: '',
    disabled: false,
    description: '',
    occurrences: 0,
    order: 0,
    useTime: false,
    values: [{
        userTrackingValueId: 0,
        userTrackingId: 0,
        name: '',
        description: '',
        type: UserTrackingType.Number,
        order: 1,
        disabled: false,
        metadata: [],
    }],
}

export const AddTracking: React.FC = () => {
    const { Api } = useApi();
    const alert = useAlertMessage();
    const [tracking, setTracking] = useState<UserTracking>(defaultTracking);
    const [postingTracking, setPostingTracking] = useState(false);
    const navigate = useNavigate();

    const onClickSaveTracking = () => {
        if (tracking) {
            setPostingTracking(true);

            Api.UserTracking.addUserTracking(tracking)
                .then(() => navigate('/trackings'))
                .catch(error => alert.addMessage(error))
                .finally(() => setPostingTracking(false));
        }
    }
    
    return (
        <Paper sx={commonSx.paper}>
            <Box>
                <Typography variant="h4">Add Tracking</Typography>
                Please enter the information about the value you would like to track.
            </Box>
            {
                tracking &&
                <React.Fragment>
                    <TrackingForm tracking={tracking} setTracking={setTracking as React.Dispatch<React.SetStateAction<UserTracking>>} />
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            mt: 2
                        }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center"
                            }}>
                            <Box sx={{
                                mr: 1
                            }}>
                                <Button color="primary" onClick={onClickSaveTracking} disabled={postingTracking}>Save</Button>
                                {postingTracking && <CircularProgress size={24} sx={commonSx.buttonProgress}></CircularProgress>}
                            </Box>
                            <Link to="/trackings" style={plainLinkStyle}>
                                <Button color="secondary" disabled={postingTracking}>Cancel</Button>
                            </Link>
                        </Box>
                    </Box>
                </React.Fragment>
            }
        </Paper>
    );
}